import { ReactNode } from 'react';

import styled from 'styled-components';

import { Spacing } from '@styles/theme';

import { Card, CardProps } from '../card';

export type AppCardPadding = 'sm' | 'md' | 'lg';
export type AppCardVariant = CardProps['variant'];

export type AppCardProps = {
  children: ReactNode;
  padding: AppCardPadding;
  variant: AppCardVariant;
};

export function AppCard(props: AppCardProps) {
  const { children, variant, padding } = props;

  return (
    <StyledAppCard variant={variant} space={paddingMap[padding]}>
      {children}
    </StyledAppCard>
  );
}

const paddingMap: Record<AppCardPadding, Spacing> = {
  sm: 2,
  md: 4,
  lg: 6,
};

const StyledAppCard = styled(Card)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});
